import { useSetRecoilState } from 'recoil'

import { appFolderAndTabStore, FolderType, TabRenderListType, appFolderAndTabStoreType } from './appFolderAndTabStore'

const useAlertMessageAction = () => {
    const setAppFolderAndTabStore = useSetRecoilState(appFolderAndTabStore)
    const setState = (newState: Partial<appFolderAndTabStoreType>) => {
        setAppFolderAndTabStore((prevState) => ({
            ...prevState,
            ...newState,
        }))
    }
    const setListFolder = (list: Array<FolderType>) => {
        setAppFolderAndTabStore((prevState) => ({
            ...prevState,
            folderList: list,
        }))
    }
    const setSeletedFolder = (param: any) => {
        setAppFolderAndTabStore((prevState) => ({
            ...prevState,
            folderSelected: param,
        }))
    }

    const setSeletedTab = (param: any) => {
        setAppFolderAndTabStore((prevState) => ({
            ...prevState,
            tabSelected: param,
        }))
    }
    const setSeletedTabIndex = (param: number) => {
        setAppFolderAndTabStore((prevState) => ({
            ...prevState,
            tabIndexSelected: param,
        }))
    }

    const setTabRenderList = (param: TabRenderListType[]) => {
        setAppFolderAndTabStore((prevState: any) => ({
            ...prevState,
            tabRenderList: param,
        }))
    }

    const setTabDirty = (_param: boolean) => {
        setAppFolderAndTabStore((prevState: any) => ({
            ...prevState,
            tabDirty: false,
            callbackDirty: undefined,
        }))
    }

    const setDirty = (_param: {
        tabDirty: boolean
        callbackDirty?: (tabIndex: number, newTabSelected: any) => void
    }) => {
        setAppFolderAndTabStore((prevState: any) => ({
            ...prevState,
            tabDirty: false,
            callbackDirty: undefined,
        }))
    }

    const resetTabDirty = () => {
        setAppFolderAndTabStore((prevState: any) => ({
            ...prevState,

            tabDirty: false,
            callbackDirty: undefined,
        }))
    }

    const clearStore = () => {
        setAppFolderAndTabStore((prevState: any) => ({
            ...prevState,
            folderList: [],
            folderSelected: {
                id: null,
                name: null,
            },
            tabSelected: {
                id: null,
                name: null,
            },
            tabRenderList: [],
            tabDirty: false,
            tabIndexSelected: null,
            callbackDirty: undefined,
        }))
    }

    return {
        setState,
        setListFolder,
        setSeletedFolder,
        setSeletedTab,
        setTabRenderList,
        setTabDirty,
        resetTabDirty,
        clearStore,
        setDirty,
        setSeletedTabIndex,
    }
}

export default useAlertMessageAction
